import React, { createContext, useState, useEffect } from 'react';

export const DataContext = createContext(null);

export const DataProvider = ({ children }) => 
{
    const loadFrom = (key, defaultValue) => 
    {
      try 
      {
        const storedValue = sessionStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : defaultValue;
      } 
      catch (error) 
      {
        console.error(`Error accessing sessionStorage for key "${key}":`, error);
        return defaultValue;
      }
      
    };

    const [loginData, setLoginData] = useState(() => loadFrom('loginData', { isLoggedIn: false }) );
    const [adminData, setAdminData] = useState(() => loadFrom('adminData', {}) );
    const [clubData, setClubData] = useState(() => loadFrom('clubData', {}) );

    // Sync loginData with sessionStorage
    useEffect(() => {
      try { sessionStorage.setItem('loginData', JSON.stringify(loginData)); }
      catch (error) { console.error('Error saving loginData to sessionStorage:', error); }
    }, [loginData]);

    useEffect(() => {
      try { sessionStorage.setItem('adminData', JSON.stringify(adminData)); }
      catch (error) { console.error('Error saving adminData to sessionStorage:', error); }
    }, [adminData]);

    useEffect(() => {
      try { sessionStorage.setItem('clubData', JSON.stringify(clubData)); }
      catch (error) { console.error('Error saving clubData to sessionStorage:', error); }
    }, [clubData]);

  return (
    <DataContext.Provider value={{ loginData, setLoginData, adminData, setAdminData, clubData, setClubData }} >
      {children}
    </DataContext.Provider>
  );
};
